import { offerService } from '@/services/offers';
import {
	CatalogueService,
	ListingService as ProductService,
} from '../../services/catalogue/index';
import { Box, Grid } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { IOfferData } from './model';
import PDPSideBarComponent from './Components/SideBar';
import { cartService } from '@/services/cart';
import { useDispatch } from 'react-redux';
import PdpSpecificationsAndInclusions from './Components/Inclusions';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import VASComponent from './Components/VAS';
import ImageCarouselComponent from './Components/ImageCarousel';
import { useLocation } from '@/hooks/useLocation';
import { useCart } from '@/hooks/useCart';
import { useWishlist } from '@/hooks/useWishlist';
import { useUser } from '@/hooks/useUser';
// import { ProductApiData } from '@/services/catalogue/models/pdp';
import { TUpdateCartItemPayload } from '@/services/cart/models/add-item-to-cart';
import { ProductConfigurationData } from '@/services/catalogue/models/productConfig';
import { HelpCenter } from '../HelpCenter';
import { useFullScreenLoader } from '@/hooks/useFullScreenLoader';
import DesignFeatureComponent from './Components/DesignFeatures';
import AwardInformationComponent from './Components/Awards';
import FloatingAddToCartComponent from './Components/SideBar/stickyComponent';
import { dataLayerPushWithEvent, emitMoeEvent } from '@/utils/dataLayer';
import PDPShimmerComponent from './pdpShimmer';
import StorytellingDataComponent from './Components/StoryTelling';
import { GetPdpTemplate } from '@/utils/getPdpDescriptions';
import { setSeoData } from '@/store/seo/seoSlice';
import VideoCallBanner from '../VideoCallBanner';
import { useNotification } from '@/hooks/useNotification';
import { NotificationSeverity } from '../NotifyToast';
import KycRequirementInfoCard from './Components/KycRequirementInfoCard';
import { useLogin } from '@/hooks/useLogin';
import {
	PrimaryActionButtonStates,
	AddToCartButton,
	GoToCartButton,
	OutOfStockButton,
} from './Buttons';
import { AvailableStockCountLabel } from './Components/SideBar/AvailableStockCountLabel';
import { IProductData } from '../search-results/model';
import PostAtcAddonsDrawer from './Components/PostAtcAddonsDrawer';
import { ApiState, BaseAxiosApiError, ViewStates } from '@/models/generics';
import {
	ProductPricings,
	getPdpEventAttributes,
	getProductPaymentPlanByTenure,
	getProductPricingByLop,
} from '@/utils/pdp';
import { RelatedProducts } from './Components/RelatedProducts';
import { PdpUrlHelper } from '@/utils/seo-url-helper';
import { LencoImage } from '@/atomic-components/Image';
import { ConfigurationsByLop } from './LopBasedConfugration';
import { GetProductAddonsApiResponseData } from '@/services/catalogue/models/product-addons-recommendations';
import GenericErrorScreen from '../ErrorScreen';

const getTargetUrlForRelatedProduct = (
	relatedProduct: IProductData,
	currentProductId: number
) => {
	return `/${PdpUrlHelper({
		permalink: relatedProduct.permalink,
		lop: relatedProduct.lineOfProduct,
	})}?source=RELATED_PRODUCT_PDP&related_product_id=${currentProductId}`;
};

const LopBasedTrustMarker = ({ lineOfProduct }: { lineOfProduct: string }) => {
	return (
		<LencoImage
			aspectRatio={4.52}
			url={
				ConfigurationsByLop.get(lineOfProduct)?.trustMarkers.imageUrl as string
			}
		/>
	);
};

const ProductDisplayPage = () => {
	const [pdpData, setPdpData] = useState<any>();
	const [offers, setOffers] = useState<IOfferData>();
	const router = useRouter();
	const searchParams = new URLSearchParams();
	const [configuration, setConfiguration] =
		useState<ProductConfigurationData>();
	const { cartActions, cart, rentCart } = useCart();
	const [addingItemToCart, setAddingItemToCart] = useState(false);
	const [tenureselect, setTenureselect] = useState<number>(12);
	const { wishlistActions } = useWishlist();
	const { selectedLocation } = useLocation();
	const [floatingAddToCart, setFloatingAddToCart] = useState(false);
	const [shimmerLoader, setShimmerLoader] = useState(false);
	const { actions } = useNotification();
	const { loginActions } = useLogin();
	const [primaryActionButtonState, setPrimaryActionButtonState] =
		useState<PrimaryActionButtonStates>(PrimaryActionButtonStates.ADD_TO_CART);
	const [productAddons, setProductAddons] = useState<IProductData[]>([]);
	const [
		postAtcProductAddonsDrawerViewState,
		setPostAtcProductAddonsDrawerViewState,
	] = useState<ViewStates>(ViewStates.NOT_VISIBLE);
	const [productPricings, setProductPricings] = useState<ProductPricings>();
	const [getRelatedProductsApiState, setRelatedProductsApiState] =
		useState<ApiState>(ApiState.LOADING);
	const [relatedProducts, setRelatedProducts] = useState<IProductData[]>([]);

	let isProductWishlisted = false;
	if (pdpData?.id) {
		isProductWishlisted = wishlistActions?.isProductWishlisted(pdpData.id);
	}
	const { isLoggedIn } = useUser();
	const { loader } = useFullScreenLoader();

	const cartID = cart?.id;
	const cityID = selectedLocation.cityId;

	const dispatch: any = useDispatch();
	const [errored, setErrored] = useState<boolean>(false);
	const getOffers = () => {
		if (!pdpData) return null;

		const dataCondition = pdpData.lineOfProduct == 'RENT' ? 'RENT' : 'BUY';
		const payload = { productId: pdpData.id };
		offerService
			.getpdpOffers(dataCondition, payload)
			.then(function (response) {
				setOffers(response.data);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};

	const canAddToCart = () => {
		return !!cartID;
	};

	const emitAtcEvents = () => {
		const attributes = getPdpEventAttributes({
			productDetails: pdpData!,
			selectedTenure: tenureselect,
		});

		emitMoeEvent('Product Added to Cart', attributes);
		dataLayerPushWithEvent('add_to_cart', {
			cart_added_product_id: pdpData?.id,
			cart_added_product_lop: pdpData?.lineOfProduct,
			cart_added_product_value: productPricings?.getBasePrice().value,
		});
	};

	function addItemToCart(payload: TUpdateCartItemPayload): Promise<void> {
		const tenureToBeSent = rentCart?.tenureSelector?.selectedTenure
			? pdpData?.upfrontOffers?.paymentPlans?.find(
					(data: any) => data.tenure == rentCart?.tenureSelector?.selectedTenure
			  )
				? rentCart?.tenureSelector?.selectedTenure
				: tenureselect
			: tenureselect;

		if (pdpData?.lineOfProduct == 'RENT') {
			payload.tenure = tenureToBeSent;
		}

		return cartService
			.addItemToCart(cartID!, payload)
			.then(async (res) => {
				cartActions.getCart();
				setPrimaryActionButtonState(PrimaryActionButtonStates.GO_TO_CART);
				actions.notifyUser({
					message: res?.data?.data?.message,
					severity: NotificationSeverity.SUCCESS,
				});
			})
			.catch((err) => {
				actions.notifyUser({
					message: err?.response?.data?.error?.message,
					severity: NotificationSeverity.ERROR,
				});
			})
			.finally(() => {
				setAddingItemToCart(false), loader.hide();
			});
	}

	const addItemToCartClicked = (currentTenure: number) => {
		if (!canAddToCart()) {
			return actions.notifyUser({
				severity: NotificationSeverity.ERROR,
			});
		}

		let payload: TUpdateCartItemPayload = {
			id: pdpData?.id ? pdpData.id : 1,
		};

		if (pdpData?.lineOfProduct == 'RENT') {
			payload.tenure = currentTenure;
		}

		emitAtcEvents();
		setAddingItemToCart(true);
		loader.show();

		const atcPromises = [getProductAddons(), addItemToCart(payload)];

		Promise.all(atcPromises).then((values: Array<any>) => {
			const getProductAddonsResult =
				values[0] as GetProductAddonsApiResponseData;

			if (
				Array.isArray(getProductAddonsResult.products) &&
				getProductAddonsResult.products?.length > 0
			) {
				openProductAddonsDrawer();
			}
		});
	};

	const goToCartClicked = () => {
		const attributes = getPdpEventAttributes({
			productDetails: pdpData!,
			selectedTenure: tenureselect,
		});
		emitMoeEvent('Go To Cart', attributes);
		router.push('/cart');
	};

	function getProductDetails() {
		setShimmerLoader(true);
		ProductService.getProduct(router.query.slug as string)
			.then((res) => {
				setShimmerLoader(false);
				setPdpData(res?.data?.data);
				setTenureselect(res?.data?.data?.upfrontOffers?.defaultTenure);
			})
			.catch((err) => {
				console.error(err);
				actions.notifyUser({
					message: err?.response?.data?.error?.message,
					severity: NotificationSeverity.ERROR,
				});
				setErrored(true);
			})
			.finally(() => loader.hide());
	}

	function getRelatedProducts() {
		// setShimmerLoader(true);
		setRelatedProductsApiState(ApiState.LOADING);
		ProductService.getRelatedProducts(router.query.slug as string, {
			...router.query,
		})
			.then((products) => {
				// setShimmerLoader(false);
				products.forEach((product) => {
					product.permalink = getTargetUrlForRelatedProduct(
						product,
						pdpData?.id as number
					);
				});

				setRelatedProducts(products);
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => setRelatedProductsApiState(ApiState.COMPLETED));
	}

	const configurations = () => {
		pdpData?.variantConfiguration?.forEach((configs: any) => {
			searchParams.append(`config[${configs.value}]`, configs.option.label);
		});
		if (cityID) searchParams.append('cityId', cityID.toString());
		if (pdpData?.variantGroupId) {
			ProductService.getProductConfig(
				pdpData.variantGroupId,
				searchParams.toString()
			)
				.then((res) => {
					setConfiguration(res.data.data);
				})
				.catch((err) => {
					// console.log('error', err);
				});
		}
	};

	function addProductToWishlist() {
		if (pdpData) {
			loader.show();
			wishlistActions
				.addItemToWishList(pdpData.id)
				.then((res) => {
					actions.notifyUser({
						message: res?.data?.message,
						severity: NotificationSeverity.SUCCESS,
					});
				})
				.catch((err: any) => {
					console.log('error', err);
					const error = err as BaseAxiosApiError;
					actions.notifyUser({
						message: error?.response?.data?.error?.message,
						severity: NotificationSeverity.ERROR,
					});
				})
				.finally(() => loader.hide());
		}
	}

	function removeProductFromWishlist() {
		if (pdpData) {
			loader.show();
			wishlistActions
				.removeItemFromWishList(pdpData.id)
				.then((res) => {
					actions.notifyUser({
						message: 'Item removed from wishlist',
						severity: NotificationSeverity.SUCCESS,
					});
				})
				.catch((err) => {
					console.log('error', err);
					actions.notifyUser({
						message: err?.response?.data?.error?.message,
						severity: NotificationSeverity.ERROR,
					});
				})
				.finally(() => loader.hide());
		}
	}

	const handleWishlisting = () => {
		if (isLoggedIn) {
			if (!isProductWishlisted) {
				dataLayerPushWithEvent('moe_event', {
					moe_event_name: 'Product Added to Wishlist',
					moe_event_data: getPdpEventAttributes({
						productDetails: pdpData!,
						selectedTenure: tenureselect,
					}),
				});
				addProductToWishlist();
			} else {
				removeProductFromWishlist();
			}
		} else {
			loginActions.showLoginFlow();
		}
	};

	const getProductAddons = () => {
		return CatalogueService.getProductAddons({
			filters: {
				collection_id:
					pdpData?.collection?.map(
						(col: { collectionId: string }) => col.collectionId
					) ?? [],
			},
		}).then((productAddonsRecommendations) => {
			setProductAddons(productAddonsRecommendations.products);
			return productAddonsRecommendations;
		});
	};

	const getProductDisplayPrice = () => {
		return productPricings?.getProductPrice().displayValue || '';
	};

	const getButtonBasedOnState = () => {
		const productPrice = getProductDisplayPrice();

		switch (primaryActionButtonState) {
			case PrimaryActionButtonStates.ADD_TO_CART:
				return (
					<AddToCartButton
						onClick={() =>
							addItemToCartClicked(pdpData?.upfrontOffers?.defaultTenure)
						}
						leftLabel={productPrice}
						isLoading={addingItemToCart}
					/>
				);
			case PrimaryActionButtonStates.GO_TO_CART:
				return (
					<GoToCartButton leftLabel={productPrice} onClick={goToCartClicked} />
				);
			case PrimaryActionButtonStates.OUT_OF_STOCK:
				return <OutOfStockButton leftLabel={productPrice} />;
		}
	};

	const getPdpCartActionButton = () => {
		const button = getButtonBasedOnState();

		const canShowStockCountLabel =
			pdpData?.isAvailable &&
			(pdpData?.availableUnits as number) < 10 &&
			!addingItemToCart;

		return (
			<FlexBox
				direction='column'
				height={'76px'}
				justifyContent='flex-end'
				alignItems='flex-end'
				mb='24px'
				id='AddToCartContainer'
				width='100%'
			>
				{canShowStockCountLabel && (
					<Box
						position={'relative'}
						bottom={'-12px'}
						right='12px'
						sx={{ zIndex: 2 }}
					>
						<AvailableStockCountLabel
							count={pdpData?.availableUnits as number}
						/>
					</Box>
				)}
				{button}
			</FlexBox>
		);
	};

	const openProductAddonsDrawer = () => {
		setPostAtcProductAddonsDrawerViewState(ViewStates.VISIBLE);
	};

	const closeProductAddonsDrawer = () => {
		setPostAtcProductAddonsDrawerViewState(ViewStates.NOT_VISIBLE);
	};

	const changeSelectedTenure = (tenure: number) => {
		setTenureselect(tenure);
		emitMoeEvent(
			'PDP Tenure Selected',
			getPdpEventAttributes({
				productDetails: pdpData!,
				selectedTenure: tenure,
			})
		);
	};

	useEffect(() => {
		setPrimaryActionButtonState(PrimaryActionButtonStates.ADD_TO_CART);

		if (pdpData) {
			getRelatedProducts();
			const selectedPaymentPlan = getProductPaymentPlanByTenure(
				pdpData?.upfrontOffers?.paymentPlans ?? [],
				tenureselect
			);

			setProductPricings(
				getProductPricingByLop({
					paymentPlan: selectedPaymentPlan,
					priceBreakUp: pdpData?.priceBreakUp!,
					lop: pdpData?.lineOfProduct!,
				})
			);
			if (pdpData.isAvailable) {
				setPrimaryActionButtonState(PrimaryActionButtonStates.ADD_TO_CART);
			} else {
				setPrimaryActionButtonState(PrimaryActionButtonStates.OUT_OF_STOCK);
			}
		}
	}, [tenureselect, pdpData]);

	useEffect(() => {
		if (router.query.slug) {
			getProductDetails();
			setPostAtcProductAddonsDrawerViewState(ViewStates.NOT_VISIBLE);
		}
	}, [router.query.slug, selectedLocation.pincode]);

	useEffect(() => {
		if (pdpData) {
			if (Object.keys(pdpData).length > 1 && pdpData?.lineOfProduct) {
				if (pdpData?.lineOfProduct) {
					getOffers();
					dispatch(
						setSeoData({
							title: pdpData?.title || pdpData?.label,
							description:
								GetPdpTemplate(
									pdpData?.vertical,
									pdpData?.title || pdpData?.label,
									pdpData?.collection[0]?.label || 'home furniture'
								) || pdpData?.inclusions[0]?.description,
						})
					);
					cartActions.getCart();
				}

				if (pdpData?.variantGroupId) {
					configurations();
				}

				if (pdpData?.id && isLoggedIn) {
					wishlistActions.getWishlists();
				}

				dataLayerPushWithEvent('pdp_viewed', {
					product_view_id: pdpData?.id,
					product_view_lop: pdpData?.lineOfProduct,
					product_view_name: pdpData?.title,
					product_view_value: productPricings?.getBasePrice().value,
				});

				const attributes = getPdpEventAttributes({
					productDetails: pdpData,
					selectedTenure: tenureselect,
				});

				dataLayerPushWithEvent('moe_event', {
					moe_event_name: 'PDP Page Loaded',
					moe_event_data: {
						...attributes,
						...(router.query?.related_product_id && {
							related_product_id: Number(router.query?.related_product_id),
						}),
					},
				});
			}
		}
	}, [pdpData]);

	useEffect(() => {
		if (pdpData && postAtcProductAddonsDrawerViewState == ViewStates.VISIBLE) {
			const attributes = getPdpEventAttributes({
				productDetails: pdpData,
				selectedTenure: tenureselect,
			});
			emitMoeEvent('Info Bottomsheet Opened', {
				...attributes,
				heading: 'add_ons_bottomsheet',
			});
		}
	}, [postAtcProductAddonsDrawerViewState]);

	if (errored) {
		return <GenericErrorScreen title='Something Went Wrong' />;
	}

	if (!pdpData || shimmerLoader)
		return (
			<Box
				sx={{
					marginTop: '100px',
					paddingLeft: '5%',
					paddingRight: '5%',
					position: 'relative',
				}}
			>
				<PDPShimmerComponent />
			</Box>
		);

	return (
		<Grid
			container
			// spacing={2}
			width='100%'
			display='flex'
			gridTemplateColumns='repeat(auto-fill, minmax(10em, 1fr))'
			sx={{
				paddingLeft: '5%',
				paddingRight: '5%',
				position: 'relative',
			}}
		>
			<Grid width='calc(100% - 448px)'>
				<Box width='100%'>
					<ImageCarouselComponent
						productDetails={pdpData}
						heroImages={pdpData?.heroes}
					/>
				</Box>

				<LencoTypography
					sx={{
						...getStyle('H11_Medium'),
						color: getColor('Gray 0'),
						marginTop: '80px',
						marginBottom: '16px',
					}}
				>
					{pdpData?.title}
				</LencoTypography>

				{pdpData?.type != 'BUNDLE' && (
					<Box sx={{ paddingBottom: '16px', width: '90%' }}>
						<LencoTypography
							sx={{
								...getStyle('P_Regular'),
								color: getColor('Gray -1'),
							}}
						>
							{pdpData?.inclusions[0]?.description}
						</LencoTypography>
					</Box>
				)}

				<PdpSpecificationsAndInclusions
					inclusions={pdpData?.inclusions}
					storytelling={pdpData?.storyTelling}
					productType={pdpData?.type}
					faq={pdpData?.faq}
					awards={pdpData?.awards}
				/>
			</Grid>

			<Grid
				container
				display='flex'
				alignSelf='flex-start'
				justifyContent='center'
				item
				width='440px'
				marginLeft='8px'
			>
				<PDPSideBarComponent
					addingItemToCart={addingItemToCart}
					productTitle={pdpData?.title}
					condition={pdpData?.condition}
					promiseDate={pdpData?.promisedDate}
					upfrontOffers={pdpData?.upfrontOffers}
					offers={offers}
					paymentValue={pdpData?.paymentValue}
					productGroup={pdpData?.productGroup}
					priceBreakUp={pdpData?.priceBreakUp}
					lineOfProduct={pdpData?.lineOfProduct}
					variantConfiguration={configuration}
					variantGroupId={pdpData?.variantGroupId}
					label={pdpData.label}
					setConfiguration={setConfiguration}
					isAvailable={pdpData.isAvailable}
					handleWishlist={handleWishlisting}
					productId={pdpData?.id}
					isProductWishlisted={
						isProductWishlisted ? isProductWishlisted : false
					}
					setTenureSelect={changeSelectedTenure}
					tenureSelect={tenureselect}
					setBottomAddToCart={setFloatingAddToCart}
					collection={pdpData?.collection}
					availableUnits={pdpData?.availableUnits}
					CartActionButton={getPdpCartActionButton()}
				/>
				<Box marginTop={'40px'}>
					{pdpData?.vas?.length > 0 && <VASComponent vas={pdpData.vas} />}
				</Box>
			</Grid>

			{pdpData?.type == 'ITEM' && (
				<Grid item md={12}>
					<DesignFeatureComponent
						designFeatures={pdpData?.inclusions[0].designFeatures}
						label={pdpData?.inclusions[0].label}
					/>
				</Grid>
			)}

			<Box m='32px 0px' width='100%'>
				<VideoCallBanner />
			</Box>

			{pdpData?.storyTelling && (
				<Grid item md={12}>
					<StorytellingDataComponent storytelling={pdpData?.storyTelling} />
				</Grid>
			)}

			{pdpData?.type == 'ITEM' && pdpData?.awards.length > 0 && (
				<Grid
					item
					md={12}
					sx={{
						justifyContent: 'end',
						alignItems: 'center',
						marginBottom: '80px',
					}}
				>
					<AwardInformationComponent awards={pdpData?.awards} />
				</Grid>
			)}

			{getRelatedProductsApiState != ApiState.LOADING && (
				<Grid item md={12} mt='32px'>
					<RelatedProducts products={relatedProducts} />
				</Grid>
			)}

			<Grid item md={12}>
				<FlexBox
					gap={4}
					sx={{
						justifyContent: 'center',
						marginBottom: '40px',
					}}
				>
					<Box width='656px'>
						<LopBasedTrustMarker lineOfProduct={pdpData?.lineOfProduct} />
					</Box>
				</FlexBox>
			</Grid>

			<FlexBox
				gap={4}
				sx={{
					width: '100%',
					justifyContent: 'space-evenly',
				}}
			>
				{/* <Box sx={{ width: '50%', height: '540px', overflow: 'hidden' }}>
					<LencoImage
						url={SustainabilityTile[pdpData.lineOfProduct]?.icon}
						aspectRatio={0.875}
					></LencoImage>
				</Box> */}
				<Box sx={{ width: '50%' }}>
					<HelpCenter />
				</Box>
			</FlexBox>

			{floatingAddToCart && (
				<FloatingAddToCartComponent
					availableUnits={pdpData?.availableUnits}
					lineOfProduct={pdpData?.lineOfProduct}
					productTitle={pdpData?.title}
					discountPercentage={
						productPricings?.getDiscountPercentage().displayValue ?? ''
					}
					strikePrice={productPricings?.getStrikePrice().displayValue ?? ''}
					productPrice={getProductDisplayPrice() as string}
					currentTenure={tenureselect}
					isAvailable={pdpData?.isAvailable}
					CartActionButton={getPdpCartActionButton()}
				/>
			)}
			<PostAtcAddonsDrawer
				open={postAtcProductAddonsDrawerViewState == ViewStates.VISIBLE}
				onClose={closeProductAddonsDrawer}
				products={productAddons}
				tenureselect={tenureselect}
			/>
		</Grid>
	);
};

export default ProductDisplayPage;
